const SET_USER = 'SET_USER';

export default (previousState = {}, { type, payload }) => {
    if (type === SET_USER) {
        return payload;
    }
    return previousState;
}